/* eslint-disable import/no-named-default */
// import * as customScheduler from './chinlai/template/scheduler'
import * as customScheduler from './sdgrouphub/template/scheduler'
// import * as customScheduler from './nytgroup/template/scheduler'

// for Hook injections - default []
export const schedulerIntegrations = customScheduler.schedulerIntegrations // customScheduler.schedulerIntegrations

// for Scheduler Console - default {}
export const schedulerServer = customScheduler.schedulerServer // customScheduler.schedulerServer